import * as React from "react";
import { cn } from "@/lib/utils";

export type AppTileProps = {
  id: number | string;
  name: string;
  icon?: React.ReactNode;
  href?: string; // navigate to app
  newTab?: boolean;
  className?: string;
};

/**
 * AppTile
 * Compact vertical tile (icon over name) matching design screenshot for apps popover.
 */
export function AppTile({
  id,
  name,
  icon,
  href,
  newTab = true,
  className,
}: AppTileProps) {
  const isLink = !!href;
  const Tag: any = isLink ? "a" : "div";
  return (
    <Tag
      data-app-id={id}
      href={isLink ? href : undefined}
      target={isLink && newTab ? "_blank" : undefined}
      rel={isLink && newTab ? "noopener noreferrer" : undefined}
      className={cn(
        "aero:group aero:flex aero:h-full aero:flex-col aero:items-center aero:justify-center aero:gap-2 aero:rounded-xl aero:border aero:border-neutral-200 aero:bg-white aero:px-4 aero:py-5 aero:text-center  aero:hover:bg-neutral-50 aero:focus:outline-none aero:focus:ring-2 aero:focus:ring-blue-500",
        className,
      )}
      aria-label={name}
    >
      <div
        className={cn("aero:flex aero:items-center aero:justify-center")}
        aria-hidden
      >
        {icon}
      </div>
      <div className="aero:text-sm aero:font-bold aero:text-foreground aero:truncate aero:w-full">
        {name}
      </div>
    </Tag>
  );
}

export default AppTile;
